/**
 * @generated SignedSource<<04fbb2bde6ed8bae3b30f5a477ad3660>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type selectedView_issueNavigator_SelectedViewContainer$data = {
  readonly viewId?: string | null | undefined;
  readonly " $fragmentType": "selectedView_issueNavigator_SelectedViewContainer";
};
export type selectedView_issueNavigator_SelectedViewContainer$key = {
  readonly " $data"?: selectedView_issueNavigator_SelectedViewContainer$data;
  readonly " $fragmentSpreads": FragmentRefs<"selectedView_issueNavigator_SelectedViewContainer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "selectedView_issueNavigator_SelectedViewContainer",
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "viewId"
        }
      ],
      "type": "JiraIssueSearchViewMetadata",
      "abstractKey": "__isJiraIssueSearchViewMetadata"
    }
  ],
  "type": "JiraView",
  "abstractKey": "__isJiraView"
};

(node as any).hash = "7af7655c76c900649cc8f8ecf6ff6734";

export default node;
